import React from "react";

/* Friendly character counter: appears once you are near the limit. */
export function CharCount({ value, max, testId }) {
  const n = (value || "").length;
  if (n < max * 0.8) return null;
  return (
    <p data-testid={testId} aria-live="polite" style={{ margin: "4px 0 0", textAlign: "right", fontFamily: "Georgia, serif", fontSize: 11.5, fontStyle: "italic", color: n >= max ? "#8b6508" : "rgba(44, 26, 18, 0.65)" }}>
      {n.toLocaleString()} / {max.toLocaleString()}{n >= max ? " · that's the limit for this note" : ""}
    </p>
  );
}
